<template>
  <div>
    <el-button class="newAdd" @click="openDialog">标记异常代理</el-button>
    <el-dialog
      title="标记异常代理"
      :visible.sync="moveDialogVisible"
      width="40%"
      center
      @close="clear"
    >
      <el-form :model="form" :rules="rules" ref="form">
        <el-form-item
          label="合伙人UID"
          :label-width="formLabelWidth"
          prop="channelUserId"
        >
          <el-input
            v-model="form.channelUserId"
            class="searchIpt"
            autocomplete="off"
          ></el-input>
        </el-form-item>

        <el-form-item
          label="标记状态"
          :label-width="formLabelWidth"
          prop="type"
        >
          <el-select v-model="form.type" placeholder="请选择">
            <el-option :key="0" label="取消标记" :value="0"> </el-option>
            <el-option :key="1" label="标记异常" :value="1"> </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="add">确定</el-button>
        <el-button size="small" @click="clear">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import moment from "moment";
import api from "../../api.js";
export default {
  data() {
    return {
      moveDialogVisible: false,
      form: {
        type: 1,
        channelUserId: "",
      },
      formLabelWidth: "140px",
      rules: {
        type: [{ required: true, message: "请选择标记状态", trigger: "blur" }],
        channelUserId: [
          { required: true, message: "请输入合伙人UID", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    openDialog() {
      this.moveDialogVisible = true;
      this.form = { type: 1, channelUserId: "" };
    },
    add() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          api
            .addMark(this.form)
            .then((res) => {
              if (res && res.code == 0) {
                this.$message.success("操作成功");
                this.clear();
              }
            })
            .catch((err) => {
              this.$message.error(err);
            });
        }
      });
    },
    clear() {
      this.moveDialogVisible = false;
      this.$refs["form"].resetFields();
    },
  },
};
</script>

<style lang="less" src="../../../../styles/button.less" scoped>
.content {
  // border: 1px solid #f5f6f7;
  padding: 20px;
  width: 100%;
  height: 200px;
  .up {
    border: 1px solid #f5f6f7;
    width: 100%;
    height: 50%;
    display: flex;
  }
  .down {
    border: 1px solid #f5f6f7;
    width: 100%;
    height: 50%;
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
  .item {
    border-right: 1px solid #f5f6f7;
    display: flex;
    width: 50%;
    height: 100%;
    justify-content: center;
    align-items: center;
    .ipt {
      width: 90%;
    }
  }
}
.btn1 {
  display: flex;
  justify-content: center;
  width: 300px;
  margin: 0 auto;
}
</style>
